/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react'
import { Box, Flex } from 'reflexbox'
import reactHtmlParser from 'react-html-parser'

import imgClosed from '../components/png/img-closed.png'
import Button from '../components/form/Button'
import QuestionMultiSingle from './question_types/QuestionMultiSingle'
import QuestionDropdown from './question_types/QuestionDropdown'
import QuestionMultiMulti from './question_types/QuestionMultiMulti'

const ScreenerPage = () => {
  const { l11Screener } = window

  const [curQuestion, setCurQuestion] = useState(null)
  const [finalEndPoint, setFinalEndPoint] = useState(null)

  const {
    launched,
    inactive_text,
    failed_gateway_text,
    introduction,
    questions,
    starting_question_uuid,
    starting_endpoint_uuid,
    target_endpoint_uuid,
    endpoints,
    start_btn_text,
    theme,
  } = l11Screener

  /*
   --- THEME STYLE
   */
  let screenerPageStyle = {}
  let buttonStyle = {}
  if (theme !== null) {
    screenerPageStyle = {
      backgroundColor: `#${theme.colour_main_background}`,
      color: `#${theme.colour_main_foreground}`,
    }
    buttonStyle = {
      backgroundColor: `#${theme.colour_button_background}`,
      color: `#${theme.colour_button_foreground}`,
    }
  }
  // --- THEME STYLE

  /* render the main page */
  const renderPage = (content) => {
    return (
      <Flex flexWrap="wrap" justifyContent="center">
        <Box width={[1, 2 / 3, 1 / 3]} py={4}>
          <div id="screener-page" style={screenerPageStyle}>
            {theme && theme.display_logo && (
              <div>
                <img src={theme.logo_filename} alt="logo" height="80" />
              </div>
            )}
            {content}
          </div>
        </Box>
      </Flex>
    )
  }

  const showQuestion = (qUuid) => {
    const question = questions.find((q) => q.uuid === qUuid)
    setCurQuestion(question)
  }

  const showFinalEndpoint = (eUuid) => {
    const endpoint = endpoints.find((e) => e.uuid === eUuid)
    setFinalEndPoint(endpoint)
  }

  const handleStartNow = () => {
    if (starting_question_uuid) {
      showQuestion(starting_question_uuid)
    } else {
      // if no questions -> show the target Endpoint
      showFinalEndpoint(target_endpoint_uuid)
    }
  }

  useEffect(() => {
    // no need to ask questions because participant gets piped to an endpoint due to a Gateway rule
    if (starting_endpoint_uuid) {
      showFinalEndpoint(starting_endpoint_uuid)
    }
  }, [])

  if (!launched) {
    return renderPage(
      <div className="ta-center">
        <img src={imgClosed} alt="This screener is not active." />
        <Box py={4}>
          <h4>{inactive_text}</h4>
        </Box>
      </div>
    )
  }

  if (failed_gateway_text) {
    return renderPage(
      <div className="ta-center">
        <Box p={4}>
          <p>{failed_gateway_text}</p>
        </Box>
      </div>
    )
  }

  // handle the selectedValue in MULTI_SINGLE and DROPDOWN questions
  const handleOnContinue = (qIdx, selectedValue, logic) => {
    let endpointUuidToPipe
    let questionUuidToPipe
    logic.forEach((rule) => {
      if (
        rule.condition &&
        rule.condition[0] &&
        ((!rule.condition[0][2] && rule.condition[0][0].trim() === selectedValue.trim()) ||
          (rule.condition[0][2] === 'not' && rule.condition[0][0].trim() !== selectedValue.trim()))
      ) {
        if (rule.pipe.type === 'END_POINT') {
          endpointUuidToPipe = rule.pipe.uuid
        } else if (rule.pipe.type === 'QUESTION') {
          questionUuidToPipe = rule.pipe.uuid
        }
      }
    })

    if (endpointUuidToPipe) {
      console.log('endpointUuidToPipe', endpointUuidToPipe)
      showFinalEndpoint(endpointUuidToPipe)
    } else if (questionUuidToPipe) {
      console.log('questionUuidToPipe', questionUuidToPipe)
      showQuestion(questionUuidToPipe)
    } else if (qIdx === questions.length - 1) {
      // if last question -> show the target Endpoint
      showFinalEndpoint(target_endpoint_uuid)
    } else {
      // just show the next question
      setCurQuestion(questions[qIdx + 1])
    }
  }

  // handle ALL the selectedValue in MULTI_MULTI questions (multiple answers)
  const handleOnContinueInMultipleAnswerQuestion = (qIdx, selectedValues, logic) => {
    let endpointUuidToPipe
    let questionUuidToPipe
    logic.forEach((rule) => {
      if (
        rule.condition &&
        rule.condition[0] &&
        ((!rule.condition[0][2] && selectedValues.includes(rule.condition[0][0].trim())) ||
          (rule.condition[0][2] === 'not' && !selectedValues.includes(rule.condition[0][0].trim())))
      ) {
        if (rule.pipe.type === 'END_POINT') {
          endpointUuidToPipe = rule.pipe.uuid
        } else if (rule.pipe.type === 'QUESTION') {
          questionUuidToPipe = rule.pipe.uuid
        }
      }
    })

    if (endpointUuidToPipe) {
      console.log('endpointUuidToPipe', endpointUuidToPipe)
      showFinalEndpoint(endpointUuidToPipe)
    } else if (questionUuidToPipe) {
      console.log('questionUuidToPipe', questionUuidToPipe)
      showQuestion(questionUuidToPipe)
    } else if (qIdx === questions.length - 1) {
      // if last question -> show the target Endpoint
      showFinalEndpoint(target_endpoint_uuid)
    } else {
      // just show the next question
      setCurQuestion(questions[qIdx + 1])
    }
  }

  const renderQuestionView = (question) => {
    if (question.format === 'MULTI_SINGLE') {
      return (
        <QuestionMultiSingle
          question={question}
          onContinue={(selectedValue) =>
            handleOnContinue(question.idx, selectedValue, question.logic)
          }
          buttonStyle={buttonStyle}
        />
      )
    }
    if (question.format === 'DROPDOWN') {
      return (
        <QuestionDropdown
          question={question}
          onContinue={(selectedValue) =>
            handleOnContinue(question.idx, selectedValue, question.logic)
          }
          buttonStyle={buttonStyle}
        />
      )
    }
    if (question.format === 'MULTI_MULTI') {
      return (
        <QuestionMultiMulti
          question={question}
          onContinue={(selectedValues) => {
            handleOnContinueInMultipleAnswerQuestion(question.idx, selectedValues, question.logic)
          }}
          buttonStyle={buttonStyle}
        />
      )
    }

    return null
  }

  const renderScreen = () => {
    // show the final endpoint
    if (finalEndPoint) {
      // no need to show anything
      if (!finalEndPoint.show_message) {
        window.location.href = finalEndPoint.url
        return null
      }

      return (
        <>
          <Box>
            <h2 className="ta-center">{finalEndPoint.heading}</h2>
            <div className="pt-medium">{reactHtmlParser(finalEndPoint.message)}</div>
          </Box>

          {finalEndPoint.button_text && finalEndPoint.url && (
            <Box py={4}>
              <Button
                className="fw-btn"
                customCSS={buttonStyle}
                label={finalEndPoint.button_text}
                clickHandler={() => {
                  window.location.href = finalEndPoint.url
                }}
              />
            </Box>
          )}
        </>
      )
    }

    // if there's a question, show it
    if (curQuestion) {
      return (
        <>
          <span className="grey-txt">
            {curQuestion.idx + 1}/{questions.length}
          </span>
          <div className="mt-small">{reactHtmlParser(curQuestion.question)}</div>

          <section className="pt-medium">{renderQuestionView(curQuestion)}</section>
        </>
      )
    }

    // show the introduction screen
    if (!starting_endpoint_uuid) {
      // to prevent the flashing
      return (
        <>
          <Box>
            <div className="pt-medium">{reactHtmlParser(introduction)}</div>
          </Box>

          <Box py={4}>
            <Button
              className="fw-btn"
              customCSS={buttonStyle}
              label={start_btn_text}
              clickHandler={handleStartNow}
            />
            <p className="ta-center">
              <small>
                Powered by <strong>Loop11</strong>
              </small>
            </p>
          </Box>
        </>
      )
    }

    return null
  }

  return renderPage(renderScreen())
}

export default ScreenerPage
